import { API_BASE_URL, getRequest, postRequest } from "../../api";

const getToken = () => sessionStorage.getItem("token");
const getUid = () => sessionStorage.getItem("uid");

const eventUrl = (moduleId, contentId, suffix = "") =>
    `${API_BASE_URL}/api/apprenant/modules/${moduleId}/contents/${contentId}/event${suffix}`;

export const fetchLearnerEventApi = (moduleId, contentId, sessionId = null) =>
    getRequest({
        url: sessionId ? `${eventUrl(moduleId, contentId)}?sessionId=${sessionId}` : eventUrl(moduleId, contentId),
        token: getToken(),
        uid: getUid(),
    });

export const registerLearnerEventApi = (moduleId, contentId) =>
    postRequest({
        url: eventUrl(moduleId, contentId, "/register"),
        data: {},
        token: getToken(),
        uid: getUid(),
    });

export const declareLearnerEventAbsenceApi = (moduleId, contentId, payload) =>
    postRequest({
        url: eventUrl(moduleId, contentId, "/absence"),
        data: payload,
        token: getToken(),
        uid: getUid(),
    });

export const completeLearnerEventIfEligibleApi = (moduleId, contentId, sessionId) =>
    postRequest({
        url: `${eventUrl(moduleId, contentId, "/complete-if-eligible")}?sessionId=${sessionId}`,
        data: {},
        token: getToken(),
        uid: getUid(),
    });
